module.exports = __webpack_public_path__ + "media/flags/it-bba84d45.svg";